import { Box, Button, Grid, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { MuiTextFieldWithFocus } from '../../../config/MaterialUIConstants';
import { useGetSequenceNumberConfig, useUpdateSequenceNumberConfig } from '../../../services/core/settings';

const InvoiceNumberSettings = ({ setShowLoader, setOpenSuccessModal, setSuccessMessage }) => {
    const { data: sequenceConfig } = useGetSequenceNumberConfig();
    const { mutateAsync: updateSequenceConfig } = useUpdateSequenceNumberConfig();
    const invoiceConfig = sequenceConfig?.invoice;

    const [prefix, setPrefix] = useState('');
    const [startNumber, setStartNumber] = useState('');
    const [initialValues, setInitialValues] = useState({
        prefix: '',
        startNumber: '',
    });

    useEffect(() => {
        if (invoiceConfig) {
            const nextPrefix = invoiceConfig?.prefix || '';
            const nextStartNumber = invoiceConfig?.sequenceNumber ? String(invoiceConfig.sequenceNumber) : '';

            setPrefix(nextPrefix);
            setStartNumber(nextStartNumber);
            setInitialValues({
                prefix: nextPrefix,
                startNumber: nextStartNumber,
            });
        }
    }, [invoiceConfig]);

    const handleCancelChanges = () => {
        setPrefix(initialValues.prefix);
        setStartNumber(initialValues.startNumber);
    };

    const handleSaveChanges = () => {
        if (!invoiceConfig?._id) return;

        const payload = {
            invoice: {
                _id: invoiceConfig._id,
                sequenceNumber: startNumber ? Number(startNumber) : 0,
            },
        };

        setShowLoader(true);
        updateSequenceConfig(payload)
            .then(() => {
                setOpenSuccessModal(true);
                setSuccessMessage('Changes Saved');
            })
            .catch((error) => {
                console.log('Error updating invoice sequence:', error);
                toast.error(error?.response?.data?.message || 'Failed to update invoice sequence');
            })
            .finally(() => {
                setShowLoader(false);
            });
    };

    return (
        <Box
            sx={{
                boxShadow: 3,
                bgcolor: 'white',
                borderRadius: '10px',
                mt: 4,
                p: 3,
            }}
        >
            <Grid container spacing={2} justifyContent="space-between" alignItems="flex-start">
                {/* Left side - Label */}
                <Grid item xs={12} md={4}>
                    <Typography variant="h5" sx={{ fontWeight: 400, fontSize: '24px' }}>
                        Invoice Number Setting
                    </Typography>
                </Grid>

                {/* Right side - Inputs only */}
                <Grid item xs={12} md={8}>
                    <Stack direction="row" alignItems="center" spacing={2} flexWrap="wrap">
                        <Box flex={1} minWidth={250}>
                            <Typography fontSize={20} fontWeight={500}>
                                Custom Invoice Numbering
                            </Typography>
                        </Box>
                    </Stack>
                    <Stack direction="row" spacing={3} mt={1} flexWrap="wrap">
                        <TextField disabled value={prefix} sx={MuiTextFieldWithFocus} placeholder="INV" />
                        <TextField
                            sx={MuiTextFieldWithFocus}
                            value={startNumber}
                            onChange={(e) => {
                                const val = e.target.value.replace(/\D/g, '');
                                if (/^\d{0,6}$/.test(val)) {
                                    setStartNumber(val);
                                }
                            }}
                            placeholder="e.g. 1, 100, 5000"
                        />
                    </Stack>
                </Grid>

                {/* Action buttons */}
                <Grid container justifyContent="flex-end" mt={3}>
                    <Grid item>
                        <Stack spacing={2} direction="row">
                            <Button className="btn-text-size-manage" variant="outlined" color="primary" onClick={handleCancelChanges}>
                                Cancel
                            </Button>
                            <Button className="btn-text-size-manage" variant="contained" color="primary" onClick={handleSaveChanges}>
                                Save
                            </Button>
                        </Stack>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default InvoiceNumberSettings;
